import IOButton from "../../../UI/Form/Button/IOButton";
import {
  customFilterOptions,
  localStorageFiltersKey,
} from "../../../utils/constants/constants";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import menuFilterSettingsFormatConverter from "../../../utils/formatConverters/menuFilterSettingsFormatConverter";
import { saveMenuFilterSettings } from "../../../store/actions/auth";
import { getFiltersFromLocalStorage } from "../../../utils/browser";
import { useShallowEqualSelector } from "../../../store";
import RememberedSettings from "./RememberSettingsGroup/RememberedSettings";

const Container = styled.div(
  ({ theme }) => `
  width: 100%;
  color: ${theme.menuPrimary ? theme.textOnPrimary : theme.text.secondary};
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  button {
    font-size: 12px;
  }
`
);

const SaveFiltersToApi = ({ filters = [], activeTab, select }) => {
  const dispatch = useDispatch();

  const { menuFilterSettingsData, currentDateTerm, dateFilters } =
    useShallowEqualSelector((state) => ({
      menuFilterSettingsData: state.auth.menuFilterSettings.data,
      currentDateTerm: state.layout.currentDateTerm,
      dateFilters: state.layout.dateFilters,
      loading: state.auth.menuFilterSettings.loading,
    }));

  const dateFilterType = customFilterOptions.find(
    (option) => `[${option.label}]` === currentDateTerm
  );

  const [showModal, setShowModal] = useState(false);
  const [applyedGroup, setApplyedGroup] = useState(null);

  const theme = useTheme();
  const filtersAndActiveTabAvailable = Array.isArray(filters) && activeTab;

  useEffect(() => {
    // Saving deprecated localStorage settings to the API.
    const filtersFromLocalStorage = getFiltersFromLocalStorage();
    if (
      menuFilterSettingsFormatConverter.local.isEmpty(
        filtersFromLocalStorage
      ) ||
      !menuFilterSettingsFormatConverter.response.isEmpty(
        menuFilterSettingsData
      )
    ) {
      return;
    }
    (async () => {
      await dispatch(saveMenuFilterSettings(filtersFromLocalStorage));
      localStorage.removeItem(localStorageFiltersKey);
    })();
  }, [dispatch, menuFilterSettingsData]);

  if (!filtersAndActiveTabAvailable) {
    return null;
  }

  return (
    <Container>
      <IOButton
        onClick={() => setShowModal(true)}
        cy="save-filters-button"
        outline
        bgPrimary={theme.menuPrimary}
        type="button"
      >
        REMEMBER SETTINGS
      </IOButton>

      {showModal ? (
        <RememberedSettings
          filters={filters}
          close={() => setShowModal(false)}
          select={select}
          applyedGroup={applyedGroup}
          setApplyedGroup={setApplyedGroup}
          dateFilterType={dateFilterType}
          dateFilters={dateFilters}
        />
      ) : null}
    </Container>
  );
};

SaveFiltersToApi.propTypes = {
  filters: PropTypes.array.isRequired,
};

export default React.memo(SaveFiltersToApi);
